import type { IconSvgObject } from './types';

const Airpod01Icon: IconSvgObject = [
  ["path", { d: "M18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 9H6.98611M21.5 9H17.0139", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["rect", { x: "7", y: "7", width: "10", height: "4", rx: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Airpod01Icon;
